import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: 'Bạn có bao giờ tưởng tượng về một thành phố nơi đèn đường tự điều chỉnh độ sáng, xe buýt đến đúng giờ nhờ dữ liệu thời gian thực, và rác thải được thu gom tự động khi thùng đầy? Đó chính là viễn cảnh của Smart City (Thành phố thông minh), nơi công nghệ và dữ liệu hợp sức để nâng cao chất lượng cuộc sống, tối ưu hóa tài nguyên và xây dựng tương lai bền vững. Vậy Smart City là gì, nó hoạt động ra sao, và tại sao lại trở thành xu hướng toàn cầu? Hãy cùng khám phá qua bài viết này!',
  keywords: 'smart city, smart city là gì, thành phố thông minh, AI, giao thông thông minh',
  ogSite: 'Smart City (Thành phố thông minh) là gì?',
  title: 'Smart City (Thành phố thông minh) là gì?',
  ogUrl: 'https://orbro.io/vi/blog/smart-city-thanh-pho-thong-minh-la-gi',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_FbjJxVkFqnMwavMoTIgFf_-9UnB2kX5Na9xMyk4PM-N4Ck60TEN4jkeQuvPyPosLlnWnfZ-4B18tfEyhZNqq9_uMVnPrPTtYy8pcuIurj1mtjktodID0hrTU9O7DUH-Ct3Y9JWYev9ccYwzDTDIGJbc8CYyEa6XjDgBnXE6kviTyNcxMtsd-moZMZaP1KoV_M-zojs_WGM7JXCt7emdDKuCsSNJIgowf0pHoN87eLeNPEhRyjfeonDVIgKFJF86NLab00JAefnjoRbMpcm3lV8JKgj0k0Prh4MKYlwR7PkWMNML-782hmac9hGft6NYncURAig4FDwzUNNugknGTaiFA-Ex--37edo_HlgK79kPEwm6y7tdXtKP156agbeuXi7ymyRvYkZ_9tXtrPCHJ9Q7dpJ99xxXCuLNWWYE6MDAURy_hIHJmDNMJ7Zyuja-EVTCb9woEidpE8dLWudUPimqUph1lcezbHSkuViglAJ4-8J0RFiC5VPHZpUX6gQ4ArVaeWNFjEw7pkLdze3n66wQA8suoiuEKxve-QOA2WE9_k4kk5Qn7rRSUAHDeh7dMIUqHkeVLdVaZ2Xycs-bWf2_VTgcf5iXcaEKCtvY7QRhiAVbX5NENbGDAeFMFDJzcV6vzZx-00r25npulGfQeZ102MpjOJVVwNFSFJfFQnhTNFg_BIoEqx5uqg0ILD4IlYtl7mrM_K75pQ4Eg3gLJMeIIopr-r-N-u5a9Lc6THws1v93pkGv_O14mmcIrvJFw8qHZ62_9izpqih5yF6YCqqYZ9bgP-0YNpyrtES1bpk2nLQooitz3vgP6gRBEmKf84fZB6G_5xcNZ1bgqu6C4pCDrPeQXQUkw9PArtx4D7hfytZNAoPEReGSSu1DazRgZ1gmLAcZPoxBtHJduTE95StLg8buvA_NB2WKZgmfkYEXnSf6Rcz852kR1iR67j8zFu_RYTerQjPa5jFwbhGjP39Tk8bOonUuVbkHfNNY2pOHdfx5ZTP_N1IXmIIWZT3XnM_ylHg6tLyWGYdPbwvlGYSGDSHlm0ubnNN4oPZqiEMqOzH107U0sthSLGnIcdTWoJqjGCcr7jshy_PgswrmZjPusXErIa47Lyn3NnCsFWN-LPP2NG9sUx3xCEk7xDcS_NcrYwVMG_KMY3mpdeDGE93vI5Z6TqK6HAmIIw9poJgrr4wfbWbAPf44XPdbageyVznvEDi11Nxsi2iqKcypVQE9lAJEb3EoA1bW3f45uvdsACAvAzu3BppV20afP_WjrGkfmF1ketOVCJ5whpCdVzRa65L6k12thCraiicnteDo9q--EqBpp8vk12egrsltMPVWvU-7qSCEmvYbwrabVKDJVCW13FJ6HJVAT1uU77Bee8wnjRBHzFadvN7J5ODVu0A6ZArXQMUBfQyHr1ovU2VSu9gxisCawdGXRrXvMRJEbeo9KqgBiUU-zZ525cMtiv45tYvQS2lSgsGd6W8h1Ixt4nANFjQ4Q4lcmq35vEgU6q-0IJe1G6Ax9zNtuVXXCqQk-QTWQ3Ext6sBJUyM8VRq4SJufX-K-INAq6_rdrVBQutpbdCuvvLa_eDPu3jCK_ny820BQdLBNtm2ApLtgonRTENX5KjguJeGQ=w1502-h1410?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-07',
  tag1: '#smartcity',
  tag2: '#thanhphothongminh',
  tag3: '#ai',
  tag4: '#giaothongthongminh',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Bạn có bao giờ tưởng tượng về một thành phố nơi đèn đường tự điều chỉnh độ sáng, xe buýt đến đúng giờ nhờ dữ liệu thời gian thực, và rác thải được thu gom tự động khi thùng đầy? Đó chính là viễn cảnh của Smart City (Thành phố thông minh), nơi công nghệ và dữ liệu hợp sức để nâng cao chất lượng cuộc sống, tối ưu hóa tài nguyên và xây dựng tương lai bền vững. Vậy Smart City là gì, nó hoạt động ra sao, và tại sao lại trở thành xu hướng toàn cầu? Hãy cùng khám phá qua bài viết này!',
      dot: ''
    },
    {
      head: '1. Smart City (Thành phố thông minh) là gì?',
      subHead: '',
      desc: 'Smart City (Thành phố thông minh) là một khái niệm chỉ việc sử dụng các công nghệ thông tin và truyền thông tiên tiến như Internet of Things (IoT), trí tuệ nhân tạo (AI), dữ liệu lớn (Big Data), và các giải pháp bền vững để cải thiện chất lượng cuộc sống của cư dân, nâng cao hiệu quả vận hành và giảm thiểu tác động môi trường.',
      dot: ''
    },
    {
      head: '2. Các thành phần cốt lõi của Smart City (Thành phố thông minh)',
      subHead: '',
      desc: 'Để trở thành một Smart City, đô thị cần tích hợp các công nghệ và giải pháp như sau:',
      dot: ''
    },
    {
      head: '',
      subHead: 'Internet vạn vật (IoT)',
      desc: '• Chức năng: Cảm biến IoT thu thập dữ liệu từ mọi ngóc ngách của thành phố, từ chất lượng không khí, mức độ ô nhiễm, đến lưu lượng giao thông.\n\n• Ví dụ: Cảm biến trên thùng rác thông minh báo cho đội thu gom khi thùng đầy, tối ưu hóa lịch trình thu gom.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Dữ liệu lớn (Big Data) và phân tích',
      desc: '• Chức năng: Xử lý khối lượng dữ liệu khổng lồ để đưa ra quyết định thông minh về quản lý tài nguyên, dịch vụ công cộng, và quy hoạch đô thị.\n\n• Ví dụ: Phân tích dữ liệu giao thông để dự đoán ùn tắc và điều chỉnh lộ trình xe buýt.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Trí tuệ nhân tạo (AI) và máy học',
      desc: '• Chức năng: Tự động hóa các quy trình, dự đoán xu hướng, và tối ưu hóa dịch vụ dựa trên dữ liệu lịch sử.\n\n• Ví dụ: AI quản lý lưới điện thông minh, phân phối điện hiệu quả hơn, giảm lãng phí.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Năng lượng bền vững',
      desc: '• Chức năng: Sử dụng năng lượng tái tạo như mặt trời, gió, và hệ thống lưới điện thông minh để giảm khí thải carbon.\n\n• Ví dụ: Đèn đường năng lượng mặt trời tự động bật tắt dựa trên ánh sáng tự nhiên và chuyển động.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Giao thông thông minh',
      desc: '• Chức năng: Tích hợp xe tự lái, hệ thống quản lý giao thông thời gian thực, và phương tiện công cộng thông minh.\n\n• Ví dụ: Xe buýt tự động điều chỉnh lộ trình để tránh kẹt xe, đến trạm đúng giờ.',
      dot: ''
    },
    {
      head: '',
      subHead: 'An ninh công cộng nâng cao',
      desc: '• Chức năng: Sử dụng camera thông minh, cảm biến, và AI để giám sát, dự đoán và ngăn chặn tội phạm.\n\n• Ví dụ: Camera nhận diện khuôn mặt giúp cảnh sát phát hiện nghi phạm trong đám đông.',
      dot: ''
    },
    {
      head: '3. Lợi ích của Smart City (Thành phố thông minh)',
      subHead: '',
      desc: 'Smart City mang lại rất nhiều các lợi ích thiết thực, từ cải thiện cuộc sống cư dân đến tối ưu hóa vận hành đô thị như:',
      dot: ''
    },
    {
      head: '',
      subHead: 'Nâng cao chất lượng cuộc sống',
      desc: '• Cư dân hưởng lợi từ dịch vụ công cộng tốt hơn, như giao thông thuận tiện, không khí sạch hơn, và an ninh đảm bảo.\n\n• Ví dụ: Ứng dụng di động cho phép cư dân báo cáo sự cố (như ổ gà) và nhận phản hồi tức thì từ chính quyền.hiệp tránh phạt và nâng cao uy tín.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Tăng tính bền vững',
      desc: '• Giảm tiêu thụ năng lượng, nước, và tài nguyên nhờ quản lý thông minh.\n\n• Ví dụ: Hệ thống tưới cây tự động điều chỉnh dựa trên độ ẩm đất, tiết kiệm nước.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Thúc đẩy tăng trưởng kinh tế',
      desc: '• Thu hút đầu tư, tạo việc làm trong lĩnh vực công nghệ, và nâng cao năng lực cạnh tranh của thành phố.\n\n• Ví dụ: Một Smart City thu hút các công ty công nghệ đến mở văn phòng, tạo ra hàng nghìn việc làm.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Quản lý tài nguyên hiệu quả',
      desc: '• Phân bổ tài nguyên như điện, nước, và không gian công cộng một cách tối ưu.\n\n• Ví dụ: Lưới điện thông minh tự động chuyển hướng nguồn điện đến khu vực có nhu cầu cao, tránh quá tải.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Tăng cường sự tham gia của cư dân',
      desc: '• Cư dân có thể đóng góp ý kiến và tham gia vào quá trình ra quyết định thông qua các nền tảng kỹ thuật số.\n\n• Ví dụ: Một ứng dụng cho phép người dân bình chọn về các dự án phát triển cộng đồng.',
      dot: ''
    },
    {
      head: '4. Thách thức khi xây dựng Smart City (Thành phố thông minh)',
      subHead: '',
      desc: 'Dù đầy hứa hẹn, nhưng việc xây dựng Smart City cũng đối mặt với một số thách thức tiêu biểu như:',
      dot: ''
    },
    {
      head: '',
      subHead: 'Chi phí đầu tư ban đầu cao',
      desc: '• Triển khai công nghệ IoT, AI, và cơ sở hạ tầng thông minh đòi hỏi nguồn vốn lớn.\n\n• Giải pháp: Hợp tác công-tư hoặc chia giai đoạn đầu tư để giảm áp lực tài chính.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Bảo mật dữ liệu và quyền riêng tư',
      desc: '• Thu thập dữ liệu quy mô lớn có thể dẫn đến rủi ro về an ninh mạng và vi phạm quyền riêng tư.\n\n• Giải pháp: Áp dụng các biện pháp mã hóa và tuân thủ quy định bảo vệ dữ liệu.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Khoảng cách số',
      desc: '• Không phải cư dân nào cũng có khả năng tiếp cận công nghệ, tạo ra sự bất bình đẳng.\n\n• Giải pháp: Đầu tư vào giáo dục kỹ thuật số và cung cấp dịch vụ công cộng qua các kênh truyền thống song song.',
      dot: ''
    },
    {
      head: '5. Ví dụ thực tế về Smart City (Thành phố thông minh)',
      subHead: '',
      desc: 'Nhiều thành phố trên thế giới đã và đang triển khai các sáng kiến Smart City với kết quả ấn tượng:\n\n• Singapore: Sử dụng IoT và AI để quản lý giao thông, năng lượng, và dịch vụ công cộng. Hệ thống thu phí đường bộ tự động ERP giúp kiểm soát lưu lượng xe vào trung tâm.\n\n• Barcelona: Áp dụng cảm biến IoT để quản lý nước tưới cây, đèn đường thông minh, và bãi đỗ xe tự động, tiết kiệm 30% chi phí vận hành.\n\n• Amsterdam: Triển khai lưới điện thông minh và xe điện công cộng, hướng đến mục tiêu không phát thải vào năm 2050.\n\nVí dụ nổi bật: Singapore được xem là một trong những Smart City tiên phong, với hệ thống quản lý nước thông minh giúp tiết kiệm hàng triệu lít nước mỗi năm.',
      dot: ''
    },
    {
      head: '6. Kết luận',
      subHead: '',
      desc: 'Smart City không chỉ là một khái niệm công nghệ mà còn là tầm nhìn cho tương lai đô thị bền vững, nơi chất lượng cuộc sống được nâng cao, tài nguyên được sử dụng hiệu quả, và cư dân được kết nối chặt chẽ hơn. Từ giao thông thông minh, năng lượng bền vững, đến an ninh công cộng, Smart City đang định hình cách chúng ta sống và làm việc trong thế kỷ 21.\n\nBạn có sẵn sàng là một phần của cuộc cách mạng đô thị này không? Hãy cùng ORBRO bắt đầu tìm hiểu và đóng góp vào việc xây dựng các Smart City ngay hôm nay để tạo ra một tương lai tươi sáng hơn cho tất cả chúng ta!',
      dot: ''
    }
  ],
  
  link: {
    page: 'access',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.auto.accessauto.title,
        title: productPurchase.purchase.auto.accessauto.title,
        serial: productPurchase.purchase.auto.accessauto.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.accessauto.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
